import { render } from "./CardTemplate.vue?vue&type=template&id=50b5d776"
const script = {}

import exportComponent from "/codebuild/output/src057020910/src/SAAS-mobile-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__